import { httpClient } from '../http/httpClient.js';
import { normalizePlan } from './planService.js';

const MY_PLAN_API_URL = '/api/plans/myPlan';

export const myPlanService = {
  getMyPlan: async () => {
    const payload = await httpClient.get(MY_PLAN_API_URL);
    return normalizePlan(payload);
  }
};
